export const getMessages = (t: (key: string) => string) => ({
  NO_DATA_FOUND: t('No data found.'),
});
